import { Grid } from '@mui/material';
import React, { useContext } from 'react';
import { AuthDataProvider } from 'src/components/authProvider';
import { ScreenConfiguration } from 'src/components/screenConfiguration';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { WarningBox } from 'src/components/warningBox/warningBox';
import { AuthClassification } from 'src/hooks/auth/auth.interface';
import { ILayoutType, ILocationGroup } from 'src/interfaces';
import { lang } from 'src/utils';

import {
  Divider,
  LocationGroupIconContainer,
  LocationGroupLink,
  LocationGroupLinkText,
  Section,
  SubHeader,
  SubHeaderText,
} from './../../DetailLocationPage.styled';

export const Channel = ({
  channelName,
  locationGroup,
  navigateToLocationGroupEdit,
  layoutType,
  screenConfigurationLabel,
}: {
  channelName: string;
  locationGroup: ILocationGroup | undefined;
  navigateToLocationGroupEdit: (id?: number | undefined) => void;
  layoutType: ILayoutType | undefined;
  screenConfigurationLabel: string;
}) => {
  const { userRole } = useContext(AuthDataProvider);

  return (
    <>
      <Section container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={5}>
          <SubHeader>{channelName}</SubHeader>
          <ScreenConfiguration
            channelName={channelName}
            hideLabel
            scale={0.03}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={7}>
          <Section container spacing={2}>
            {userRole !== AuthClassification.OWNER_OPERATOR && (
              <>
                <Grid item xs={6} md={4}>
                  <SubHeader>{lang.locationGroup}</SubHeader>
                  {locationGroup && !locationGroup.is_default ? (
                    <LocationGroupIconContainer>
                      <LocationGroupLinkText>
                        <CustomTooltip
                          width={500}
                          placement="right"
                          title={locationGroup.name}
                          overflowLineNumber={1}>
                          <LocationGroupLink
                            onClick={() =>
                              navigateToLocationGroupEdit(locationGroup?.id)
                            }>
                            {locationGroup.name}
                          </LocationGroupLink>
                        </CustomTooltip>
                      </LocationGroupLinkText>
                    </LocationGroupIconContainer>
                  ) : (
                    <WarningBox>{lang.assignToLocationGroup}</WarningBox>
                  )}
                </Grid>
              </>
            )}

            <Grid item xs={6} md={4}>
              <SubHeader>{lang.channelType}</SubHeader>
              <SubHeaderText>{layoutType?.name}</SubHeaderText>
            </Grid>

            <Grid item xs={6} md={4}>
              <SubHeader>{lang.screenConfiguration}</SubHeader>
              <SubHeaderText>{screenConfigurationLabel}</SubHeaderText>
            </Grid>
          </Section>
        </Grid>
      </Section>
      <Divider />
    </>
  );
};
